import { BaseApiUrl } from "../../../configVariables";
import ConnectToAvailableTeamsType from "../../../model/ConnectToAvailableTeamsType";
import IConnectToTeam from "../../../model/IConnectToTeam";
import { BrokerConnectionDetails } from "../../../model/brokerConnections/BrokerConnectionDetails";
import apiClient from "../../../utils/apiClient";

export const fetchConnectToTeams = async () => {
  let url = `${BaseApiUrl}/connectTo/getAvailableTeamsByType('${ConnectToAvailableTeamsType.Help}')`;
  return await apiClient.get<IConnectToTeam[]>(url);
};

export const fetchConnectToTeamsForReporting = async () => {
  const url = `${BaseApiUrl}/connectTo/getTeamsForReporting`;
  return await apiClient.get<IConnectToTeam[]>(url);
};

export const getBrokerConnectionDetails = async (brokerConnectionId: string) => {
  const result = await apiClient.get<BrokerConnectionDetails>(`${BaseApiUrl}/connectTo/brokerConnection/${brokerConnectionId}`);
  return result.data;
};